import { media } from '../Theme/constants';
import { useMediaQuery } from 'react-responsive';

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: media.tablet });
  return isMobile ? children : null;
};

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: media.desktop });
  return isDesktop ? children : null;
};

export { Mobile, Desktop };
